import CompanyDetailsTemplate from './company-details.component.html';
import './company-details.component.scss';

/**
 * @ngdoc controller
 * @name CompanyDetailsController
 * @module portfolium.CompanyDetailsController
 **/
class CompanyDetailsController {
    constructor($pfUser) {
        this._$pfUser = $pfUser;
    }

    $onInit() {
        this.user = this._$pfUser.getUser();
    }
}

CompanyDetailsController.$inject = ['$pfUser'];

/**
 * @ngdoc component
 * @name CompanyDetailsComponent
 * @module portfolium.CompanyDetailsComponent
 **/
export const CompanyDetailsComponent = {
    bindings: {
        'company': '<',
    },
    template: CompanyDetailsTemplate,
    controller: CompanyDetailsController,
    controllerAs: '$ctrl'
};
